import axios from 'axios'

const API_URL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL + "/api/categorie/" : '/api/categorie/'; 


// Get
const getAllCategories = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.get(API_URL, config)
  return response.data
}

// Create
const createCategoria = async (categoriaData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.post(API_URL, categoriaData, config)
  return response.data
}

// Update
const updateCategoria = async (categoriaData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const { id, ...body } = categoriaData
  const response = await axios.put(API_URL + id, body, config)
  return response.data
}

// Delete
const deleteCategoria = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.delete(API_URL + id, config)
  return response.data
}

// Restore (un-hide a default categoria previously hidden for this user)
const restoreCategoria = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.post(API_URL + id + '/restore', {}, config)
  return response.data
}

const categorieService = {
  getAllCategories,
  createCategoria,
  updateCategoria,
  deleteCategoria,
  restoreCategoria,
}

export default categorieService